import React, { useEffect, useState } from 'react'
import { Box, FormControl, InputLabel, Typography } from '@mui/material'
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { ApiScoreCardList } from '../../../apiService/Core/Apicall.tsx';
import Loading from '../../Loader/Loading.tsx';

function ScoreCard() {
    const [months, setmonths] = useState<any>(dayjs())
    const [scorecardlist, setscorecardlist] = useState<any>([])

    useEffect(() => {

        const scorecardlist = async () => {
            const data = `?month=${months.month()+1}&year=${months.year()}`
             try {
                 const response = await ApiScoreCardList(data)
                 setscorecardlist(response.data)
             } catch (error) {
                console.log(error)
             }
        }
        scorecardlist()
    }, [months])

    return (
        <Box className='p-3'>
            <Box className='d-flex align-items-center justify-content-between' borderBottom='1px solid black'>
                <Typography className='fw-bold' variant='h5'> Score Cards</Typography>
                <FormControl sx={{ width: "7%" }}>
                    {/* <InputLabel id="demo-simple-select-label" shrink={false}>Select Months  <span className='text-danger'>*</span></InputLabel> */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker value={months} className='bg-white border-10  input-border-none'
                            views={['month', 'year']}
                            format="MMM-YY"
                            onChange={(e) => { setmonths(e); }}

                            slots={{
                                openPickerIcon: ArrowDropDownIcon, // Replaces calendar icon
                            }}
                        />
                    </LocalizationProvider>
                </FormControl>
            </Box>
            <Box className='mt-3'>
                <Box className='border-10' overflow='hidden' border='1px solid #0000002a'>
                    <Box className='d-flex custom-bg' borderBottom='1px solid black'>
                        <Typography fontWeight={550} borderRight='1px solid gold' fontSize='14px' className='p-2 col-2 text-center'>CREATION DATE</Typography>
                        <Typography fontWeight={550} borderRight='1px solid gold' fontSize='14px' className='p-2  col-1 text-center'>VISIT DATE</Typography>
                        <Typography fontWeight={550} borderRight='1px solid gold'fontSize='14px' className=' p-2  col-2'>VENUE NAME</Typography>
                        <Typography fontWeight={550} borderRight='1px solid gold' fontSize='14px' className='p-2  col-4'>SCORE</Typography>
                        <Typography fontWeight={550} className='col-3 p-2 '>STATUS</Typography>
                    </Box>
                    {scorecardlist && scorecardlist.map((item: any, index: any) => (
                    <Box className='d-flex' bgcolor='#0000001A' sx={{ borderBottom: index !== scorecardlist.length - 1 ? '1px solid black' : 'none' }}>
                        <Typography borderRight='1px solid gold' fontSize='14px' className='p-2 col-2 text-center'>{new Date(item?.reportCreatedDate).toLocaleString('en-GB', { hour12: true })}</Typography>
                        <Typography borderRight='1px solid gold' fontSize='14px' className='p-2 col-1 text-center'>{new Date(item?.inspectionDateTime).toLocaleDateString('en-GB')}</Typography>
                        <Typography borderRight='1px solid gold' fontSize='14px' className='p-2  col-2 text-start'>{item?.venueName}</Typography>
                        <Typography borderRight='1px solid gold' fontSize='14px' className='p-2 col-4 text-start'>
                            <Box border='1px solid #ADB792' overflow='hidden' className='border-10'>
                                <Box className='custom-bg text-dark p-1' sx={{width:`${item?.finalScore}%`}}>{item?.finalScore}</Box>
                                </Box>
                            </Typography>
                        <Typography fontSize='14px' className='p-2 col-3 text-start' sx={{color:item?.statusDesc==='Confirmed' ? 'green':'red'}}>{item?.statusDesc}</Typography>
                    </Box>
                    ))} 

                </Box>
            </Box>
            <Loading/>
        </Box>
    )
}

export default ScoreCard
